import React, { useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Button } from 'antd';
import { mdiMenuLeft, mdiMenuRight } from '@mdi/js';
import Ninja from '@ninja';
import Icon from '@mdi/react';
import ninjaApi from 'store/redux/apis';
import TrafficReportingOverviewCard from './components/TrafficReportingOverviewCard';
import { TrafficReportingOverviewMetrics } from './components/TrafficReportingOverviewMetrics';
import { useJourneyReport } from 'modules/ReportModule/context/useJourneyReport';

const TrafficReportingOverview = () => {
  const [trafficReportingOverviewQuery, { data = [], isLoading, isFetching }] =
    ninjaApi.useLazyTrafficReportingOverviewQuery();

  const { filter } = useJourneyReport();

  useEffect(() => {
    if (!filter?.website_id) return;
    trafficReportingOverviewQuery({
      filters: {
        ...filter,
      },
    }).unwrap();
  }, [filter]);

  const Arrow = ({ type, className, onClick }) => {
    const iconPath = type === 'next' ? mdiMenuRight : mdiMenuLeft;
    const style = {
      display: 'block',
      zIndex: 2,
      fontSize: '24px',
      ...(type === 'next' ? { right: -23 } : {}),
    };
    return (
      <div className={className} style={style} onClick={onClick}>
        <Button size='small' icon={<Icon path={iconPath} color={Ninja.colors.info} size={1.2} />} />
      </div>
    );
  };

  const NextArrow = (props) => <Arrow type='next' {...props} />;
  const PrevArrow = (props) => <Arrow type='prev' {...props} />;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className='my-2 mx-4'>
      <Slider {...settings}>
        {TrafficReportingOverviewMetrics.map((metric, key) => (
          <TrafficReportingOverviewCard
            {...metric}
            key={key}
            isLoading={isLoading || isFetching}
            metricKey={metric.key}
            totals={data?.totals}
            data={data?.data}
            dataKey={metric.key}
          />
        ))}
      </Slider>
    </div>
  );
};

export default TrafficReportingOverview;
